$(document).ready(function () {

  if (!sessionStorage.getItem("popupShown")) {
    $('.image-popup-block').show();
    $('body').addClass('active_popup');
  } else {
    $('.image-popup-block').hide();
    $('body').removeClass('active_popup');
  }

$(document).on('click','.content-image',function() {
    var image_html = $(this).html();
    console.log(image_html);
    $('.freeze_image-popimg').html(`<div class="freezer__image">${image_html}</div>`);
    $('.freezer_image--popup-wrap').addClass('show');
});


$(document).on('click', '.close_icon', function () {
    $('.freezer_image--popup-wrap').removeClass('show');

    $('.image-popup-block').hide();
    $('body').removeClass('active_popup');
    sessionStorage.setItem("popupShown", "true");
  });

setTimeout(function(){
    $('.image-popup-block').hide();
    $('body').removeClass('active_popup');
    sessionStorage.setItem("popupShown", "true");
},5000);

//  $('.award-section-wrapperr.swiper').each(function(index, element) {
//     const $el = $(element);
//     const interval = setInterval(function() {
//         if ($el.hasClass('swiper-initialized')) {
//             clearInterval(interval);
//             setTimeout(function() {
//                 $el.find('.swiper-button-next-1').click();
//                 $el.find('.swiper-button-prev-1').click();
//             }, 200);
//         }
//     }, 100); // check every 100ms
// });

  /** START:- tab section js**/
// $('.partner-header .rich-text__buttons').on('click', function () {
//   $('html, body').animate({
//     scrollTop: $(window).scrollTop() + 2800
//   }, 300); // 300ms animation duration
// });
// logos section
    
// end logos section
  
$('.partner-header .rich-text__buttons').on('click', function () {
  const startPosition = window.pageYOffset;
  const targetPosition = startPosition + 3300;
  const distance = targetPosition - startPosition;
  const duration = 600;
  let startTime = null;

  function animation(currentTime) {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const run = ease(timeElapsed, startPosition, distance, duration);
    window.scrollTo(0, run);
    if (timeElapsed < duration) requestAnimationFrame(animation);
  }

  // Easing function for smooth acceleration/deceleration
  function ease(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
  }
  requestAnimationFrame(animation);
});

  
  $(".tab-nav-block .tabheading:first-child").addClass("active");
  $(".tab-content").hide();
  $(".tab-content:first").show();

  // Click function
  $(document).on("click", ".tab-nav-block .tabheading", function () {
    $(".tab-nav-block .tabheading").removeClass("active");
    $(this).addClass("active");
    $(".tab-content").hide();

    var activeTab = $(this).find("a").attr("href");
    $(activeTab).fadeIn();
    return false;
  });

  /** END:- tab section js**/

  $(document).on("click", ".video-toggle", function () {
    var video = $(".video-wrap video").get(0);

    if ($(this).hasClass("play")) {
      video.play();
      $(this).removeClass("play").addClass("pause");
    } else {
      video.pause();
      $(this).removeClass("pause").addClass("play");
    }
  });

  /** START:- about journey section **/
  $(".js-main-nav-block").slick({
    dots: false,
    speed: 300,
    arrows: true,
    slidesToShow: 10,
    slidesToScroll: 1,
    asNavFor: ".js-data-nav-block",
    focusOnSelect: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          dots: false,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".js-data-nav-block").slick({
    dots: false,
    speed: 300,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
   $('.timeliner-section-main').slick({
      touchMove: true,          // Allow touch/mouse dragging
      swipeToSlide: true,
      autoplaySpeed: 2000,
      infinite: true,
      cssEase: 'linear',
      draggable: true,
      swipe: true,
      pauseOnHover: true,
      pauseOnFocus: false,
      centerMode: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      // prevArrow: '<button type="button" class="slick-prev-timeline swiper-button-prev-1"><svg width="12" height="26" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.00083 5.40151C6.01948 5.40151 3.59933 2.98136 3.59933 0H0.402344C0.402344 2.88553 1.82547 5.44018 4.00779 7C1.82547 8.55982 0.402344 11.1145 0.402344 14H3.59933C3.59933 11.0186 6.01948 8.59849 9.00083 8.59849V5.40151Z" fill="#0D9BC7"></path></svg></button>',
      nextArrow: '<button type="button" class="slick-next-timeline swiper-button-next-1"><svg width="12" height="26" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.00083 5.40151C6.01948 5.40151 3.59933 2.98136 3.59933 0H0.402344C0.402344 2.88553 1.82547 5.44018 4.00779 7C1.82547 8.55982 0.402344 11.1145 0.402344 14H3.59933C3.59933 11.0186 6.01948 8.59849 9.00083 8.59849V5.40151Z" fill="#0D9BC7"></path></svg></button>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
          }
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
$(document).on("click", ".js-main-nav-block .journey-tabheading", function (event) {
  event.stopPropagation();
  
  var $_this = $(this);
  var $_closest = $_this.closest(".slick-slide");
  var index = parseInt($_closest.attr("data-slick-index"), 10);

  if (!isNaN(index)) {
    $(".js-main-nav-block .slick-slide").removeClass("active");
    $(".js-main-nav-block .journey-tabheading").removeClass("active");

    $_closest.addClass("active");
    $_this.addClass("active");

    $(".js-data-nav-block").slick("slickGoTo", index);
  }
});

$(".js-main-nav-block").on("afterChange", function (event, slick, currentSlide) {
  $(".js-main-nav-block .slick-slide").removeClass("active");
  $(".js-main-nav-block .journey-tabheading").removeClass("active");

  var $currentSlide = $('.js-main-nav-block .slick-slide[data-slick-index="' + currentSlide + '"]');
  $currentSlide.addClass("active");
  $currentSlide.find(".journey-tabheading").addClass("active");
});



  /** END:- about journey section **/

$('.js-slider-content').each(function () {
  var deskSlide = $(this).data('desk-slide') || 4;
 $(this).slick({
    slidesToShow: deskSlide,
    slidesToScroll: 1,
    arrows: true,
    autoplay: false,
    touchMove: true,
    swipeToSlide: true,
    autoplaySpeed: 2000,
    infinite: true,
    cssEase: 'ease-in-out',
    edgeFriction: 0, 
    draggable: true,
    swipe: true,
    pauseOnHover: true,
    pauseOnFocus: false,
    centerMode: false,
    dots: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  });
});



  $(".js-about-slider").slick({
    dots: true,
    speed: 300,
    arrows: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".js-column-slider").slick({
    dots: false,
    speed: 300,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });
  var $arrows = $(".js-column-slider .slick-prev,.js-column-slider .slick-next");
  var $arrowWrapper = $('<div class="custom-arrows multicolumn-arrows"></div>').append($arrows);
  $(".js-column-slider .slick-list .multicolumn-card__info").append($arrowWrapper);

  
  // START: video testimonial slider
  $(".js-video-slider").slick({
    dots: false,
    speed: 300,
    arrows: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2.1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2.1,
        },
      },
    ],
  });
  var $arrows = $(".js-video-slider .slick-prev,.js-video-slider .slick-next");
  var $arrowWrapper = $('<div class="custom-arrows"></div>').append($arrows);
  $(".js-video-slider .slick-list").append($arrowWrapper);
  // END:- video testimonial slider

  
  /** START:- go to top button **/
  $(window).scroll(function () {
    if ($(this).scrollTop() > 800) {
      $("#goTopBtn").fadeIn();
    } else {
      $("#goTopBtn").fadeOut();
    }
  });

  $("#goTopBtn").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 800);
    return false;
  });

  /** END : go to top button **/

  // START:- about award section
  // $(".awards-slider").each(function () {
  //   var slidesToShow = $(this).data("slides") || 5; // Default to 5 if not set

  //   $(this).slick({
  //     slidesToShow: slidesToShow,
  //     slidesToScroll: 1,
  //     infinite: true,
  //     autoplay: false,
  //     autoplaySpeed: 3000,
  //     arrows: true,
  //     dots: false,
  //     centerMode: true,
  //     responsive: [
  //   {
  //     breakpoint: 768,
  //     settings: {
  //       slidesToShow: 1,
  //       arrows: true,
  //     }
  //   },
  //   {
  //     breakpoint: 480,
  //     settings: {
  //       slidesToShow: 1,
  //       arrows: true
  //     }
  //   }
  // ]
  //   });
  // });

  // function adjustSlideSize() {
  //   let $slides = $(".awards-slider .slick-slide");
  //   let $activeSlides = $(".awards-slider .slick-active");

  //   $slides
  //     .removeClass(
  //       "active slide-adjacent-left slide-adjacent-right slide-second-outer-left slide-second-outer-right"
  //     )
  //     .css({ transform: "", margin: "0" });

  //   let centerIndex = Math.floor($activeSlides.length / 2);

  //   $activeSlides.eq(centerIndex).addClass("active").css({
  //     transform: "",
  //     opacity: "1",
  //     margin: "auto",
  //   });

  //   if ($activeSlides.eq(centerIndex - 1).length) {
  //     $activeSlides
  //       .eq(centerIndex - 1)
  //       .addClass("slide-adjacent-left")
  //       .css({
  //         transform: "",
         
  //       });
  //   }

  //   if ($activeSlides.eq(centerIndex + 1).length) {
  //     $activeSlides
  //       .eq(centerIndex + 1)
  //       .addClass("slide-adjacent-right")
  //       .css({
  //         transform: "",
         
  //       });
  //   }

  //   if ($activeSlides.eq(centerIndex - 2).length) {
  //     $activeSlides
  //       .eq(centerIndex - 2)
  //       .addClass("slide-second-outer-left")
  //       .css({
  //         transform: "",
        
  //         margin: "0 0 0 auto",
  //       });
  //   }

  //   if ($activeSlides.eq(centerIndex + 2).length) {
  //     $activeSlides
  //       .eq(centerIndex + 2)
  //       .addClass("slide-second-outer-right")
  //       .css({
  //         transform: "",
  //         margin: "",
  //       });
  //   }
  // }

  // $(".awards-slider").on("afterChange", function () {
  //   adjustSlideSize();
  // });

  // $(window).on("resize", function () {
  //   adjustSlideSize();
  // });

  // // Initial call
  // setTimeout(adjustSlideSize, 100);

  // END:- about award section

  // START:- product info block
  // Initialize for product info block
  setupTabSwitching(".js-info-heading", ".product-info-wrapper .tab-content");
  // END:- product info block

//START:- media blog
  // Initialize for media blog
  setupTabSwitching(".js-media-heading", ".js-media-content");
// END:- media blog

var $prt_feat_arrow = $('.partner-feature-section .slick-prev,.partner-feature-section .slick-next'),
  $prt_feat_arrowrraper = $('<div class="custom-arrows"></div>').append($prt_feat_arrow);
  $('.partner-feature-section .awards-slider').append($prt_feat_arrowrraper);



/** START : business form**/

// When select is focused, open the wrapper
$(document).on('click', '.select__wrapper', function () {
  $(this).closest('.custom-select-wrapper').toggleClass('open');
});
$(document).on('click', function (e) {
  if (!$(e.target).closest('.custom-select-wrapper').length) {
    $('.custom-select-wrapper').removeClass('open');
  }
});


  

  /** END : business form**/

if (isLaptopOrDesktop()) {
 $('.mainmedia').slick();
} else {
   $('.mainmedia').unslick();
}
  
});


function isLaptopOrDesktop() {
  const ua = navigator.userAgent;
  return !/Mobi|Android|iPhone|iPad|iPod/i.test(ua);
}




function setupTabSwitching(buttonSelector, contentSelector) {
  $(document).on("click", buttonSelector, function () {
    const $clicked = $(this);
    const target = $clicked.data("tab");

    const $buttons = $(buttonSelector);
    const $contents = $(contentSelector);

    $buttons.removeClass("active");
    $clicked.addClass("active");

    $contents.each(function () {
      const $content = $(this);
      if ($content.hasClass(target)) {
        $content.addClass("active").show();
      } else {
        $content.removeClass("active").hide();
      }
    });
  });
}


  function equalizeCardHeights() {
    var maxHeight = 0;
    $('.multicolumn-card__info').css('height', 'auto');
    $('.multicolumn-card__info').each(function() {
      var thisHeight = $(this).outerHeight();
      if (thisHeight > maxHeight) {
        maxHeight = thisHeight;
      }
    });
    $('.multicolumn-card__info').css('height', maxHeight + 'px');
  }
  $(document).ready(function() {
    equalizeCardHeights();
  });
  $(window).on('resize', function() {
    equalizeCardHeights();
  });

function adjustPadding() {
  var $outer = $('.home-productRange-section-wrapper');
  var $inner = $('.productRange-content-container');
  var $target = $('.market-segments .page-width');

  if ($outer.length && $inner.length && $target.length) {
    var outerWidth = $outer.outerWidth();
    var innerWidth = $inner.outerWidth();
    var diff = (outerWidth - innerWidth) / 2;
    $target.css('padding-left', diff + 'px');
  } else {
    console.warn('One or more elements not found.');
  }
}


var about_swiper = new Swiper(".about-us-slider", {
  loop: true,
  centeredSlides: true,
  slidesPerView: 5,
  spaceBetween: 0,
  speed: 600,
  navigation: {
    nextEl: '.swiper-button-next-1',
    prevEl: '.swiper-button-prev-1'
  },
  // pagination: {
  //   el: '.swiper-pagination',
  //   clickable: true
  // },
  breakpoints: {
    0: {          
      slidesPerView: 1
    },
    768: {        
      slidesPerView: 5
    },
    1024: {       
      slidesPerView: 5
    }
  }
});


var swiper = new Swiper(".mySwiper", {
  loop: true,
  centeredSlides: true,
  spaceBetween: 0,
  speed: 600,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  // pagination: {
  //   el: '.swiper-pagination',
  //   clickable: true
  // },
  breakpoints: {
    0: {          
      slidesPerView: 1
    },
    768: {        
      slidesPerView: 3
    },
    1024: {       
      slidesPerView: 3
    }
  }
});


// hover header work on it
document.addEventListener('DOMContentLoaded', function() {
  const megaMenus = document.querySelectorAll('.mega-menu');
  let closeTimeout;
  
  megaMenus.forEach(menu => {
    const summary = menu.querySelector('summary');
    const content = menu.querySelector('.mega-menu__content');
    
    menu.addEventListener('mouseenter', () => {
      // Clear any pending close timeouts when re-entering
      clearTimeout(closeTimeout);
      menu.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
      menu.classList.add('hover-active');
    });
    
    menu.addEventListener('mouseleave', () => {
      // Set timeout to close after 2 seconds
      closeTimeout = setTimeout(() => {
        menu.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
        menu.classList.remove('hover-active');
      }, 1000); // 2000 milliseconds = 2 seconds
    });
    
    // Maintain keyboard accessibility
    summary.addEventListener('click', (e) => {
      if (window.innerWidth > 989) {
        e.preventDefault(); // Prevent default on desktop
      }
    });
  });
});
// arrow js
function updateMegaMenuPosition() {
  const corporate = document.getElementById('HeaderMenu-corporate');
  
  if (corporate) {
    const leftPosition = corporate.offsetLeft + corporate.offsetWidth / 2 - 50;
    const styleSheets = document.styleSheets;
    
    for (let i = 0; i < styleSheets.length; i++) {
      const styleSheet = styleSheets[i];
      try {
        const rules = styleSheet.cssRules || styleSheet.rules;
        
        for (let j = 0; j < rules.length; j++) {
          const rule = rules[j];
          if (rule.selectorText === 'div#MegaMenu-Content-1:before') {
            rule.style.left = `${leftPosition}px`;
            return;
          }
        }
      } catch (e) {
        continue;
      }
    }
    
    const style = document.createElement('style');
    style.innerHTML = `
      div#MegaMenu-Content-1:before {
        left: ${leftPosition}px;
      }
    `;
    document.head.appendChild(style);
  }
}

// Run when DOM is fully loaded
document.addEventListener('DOMContentLoaded', function() {
  updateMegaMenuPosition();
});

// Also update on window resize
window.addEventListener('resize', updateMegaMenuPosition);
$(document).ready(adjustPadding);
$(window).on('resize', adjustPadding);